<template>
    <div id="batchUpdateShipment">
        <a-modal
            :title="$t('pubGicSet.BatchUpdateShipment')"
            v-model="visible"
            width="50%">
            <template slot="footer">
                <a-button  @click="saveBathShipment" size="small" type="primary" :disabled="isDisab">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-row>
                <a-col span="24" style="padding-left: 20px">
                    <nb-editfrom :ifBatchUpdate=true :labelSpan="labelSpan" ref="bathUpdatFromRef" :QueryUpdatas="fromData" :isbtn="false" v-on:neibucancelModalVisible="neibugetSubvidible"></nb-editfrom>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import nbEditfrom from '../components/nbEditfrom.vue'
    export default{
        components: {
            nbEditfrom,
        },
        data(){
            return{
                labelSpan: '24',
                visible: false,
                fromData: {},
                paramsData: {},
                isDisab: false,
            }
        },
        methods:{
            show(param){
              this.visible = true
              this.paramsData = param
              this.fromData = {}
              this.init()
            },
            init(){
                let params = this.paramsData
                params.type = 'update'
                 ajax.get(api.BATCHUPDATESHIPMENT,params).then(res=>{
                     if(res.code == 200) {
                         this.fromData = res.data
                         for(let i in this.fromData.data){
                             this.fromData.data[i].checked = true
                         }
                     }
                 })
            },
            saveBathShipment(){
                this.$refs.bathUpdatFromRef.batchUpdateShipement()
            },
            neibugetSubvidible(val){
                this.isDisab = true
                let checkedBach = []
                for(let i in this.fromData.data){
                    if(this.fromData.data[i].checked && this.fromData.data[i].disaplyable){
                        checkedBach.push(this.fromData.data[i].detailUid)
                    }
                }
                let arr = []
                if(checkedBach.length > 0){
                   for(let i in val){
                       if(checkedBach.indexOf(val[i].key) > -1){
                           arr.push(val[i])
                       }
                   }
                }
                let params = {
                    dataUidList: this.paramsData.uidList,
                    params: arr,
                    type: 'update',
                    subModuleCode:this.paramsData.subModuleCode,
                    btnGmcUid: this.paramsData.btnGmcUid,
                    btnUid: this.paramsData.btnUid
                }
                ajax.post(api.BATCHUPDATESHIPMENT,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg,2);
                    }else{
                        this.$customMessage.error(res.msg,2);
                    }
                    this.isDisab = false
                })
            }
        }
    }
</script>